// getLivestreamFeedSortings.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import {
  LIVESTREAM_FEED_SORTINGS,
  LIVESTREAM_FEED_SORTINGS_V2,
} from '../RemoteConfigKeys.js';

import getRemoteConfigData from './getRemoteConfigData.js';

/**
 * Select livestream feed sortings by filter type
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} filterType - filter type.
 * @return {string} The selected livestream feed sortings.
 */
const getLivestreamFeedSortings = createCachedSelector(
  state => getRemoteConfigData(state, LIVESTREAM_FEED_SORTINGS),
  state => getRemoteConfigData(state, LIVESTREAM_FEED_SORTINGS_V2),
  (state, filterType) => filterType,
  (sortings, sortingsV2, filterType = 'v1') => {
    return filterType === 'v1' ? sortings : sortingsV2;
  }
)((state, filterType) => `${filterType}`);

export default getLivestreamFeedSortings;
